/**
 * Created by yuxin.zhang on 2018/09/07.
 * 密码输入框伪装
 */

import React, { useState } from 'react';

import TogglePassword from '_src/common/components/TogglePassword';

import './index.less';

export default function InputPassword(props) {
  const [showPassword, setShowPassword] = useState(false);
  const onToggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  let inputType = showPassword ? 'text' : 'password';
  const style = {};

  if (navigator.userAgent.match(/webkit/i)) {
    inputType = 'text';
    if (!showPassword) {
      style.WebkitTextSecurity = 'disc';
    }
  }

  return (
    <React.Fragment>
      <div className="input-password-box">
        <input {...props} type={inputType} style={style} />
        <TogglePassword
          className="input-password-toggle-eye"
          showPassword={showPassword}
          onToggleShowPassword={onToggleShowPassword}
        />
      </div>
    </React.Fragment>
  );
}
